import React from 'react';
import {  Tooltip } from '@material-ui/core';
export function IconWithTooltip(props) {
    return (
        <Tooltip title={props.title}><div>{props.children}</div></Tooltip>
    )
}